import Header from "../header/Header";
import Hero from "../hero/Hero";
import { useTranslation } from "react-i18next";
import { services } from "../../data";
import "./inner.scss";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/footer";
import Mobilecontact from "../../helper/mobilecontact";
import { Link, useParams } from "react-router-dom";

const Inner = () => {
  const { t } = useTranslation();
  const { lang = "ka" } = useParams();

  return (
    <>
      <Header />
      <Hero />
      <main className="container" id="services">
        <div className="left-side"></div>
        <div className="middle-side">
          <h2 className="services-title">{t("header2")}</h2>
          <div className="service">
            {services.map((service, index) => (
              <Link
                to={`/${lang}/services/${service.slug}`}
                key={index}
                className="services-container"
              >
                <img
                  className="service-img"
                  src={service.img}
                  alt={service.alt}
                  loading="lazy"
                />
                <div className="service-name-container">
                  <h3 className="service-name">{t(service.name)}</h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className="right-side"></div>
      </main>
      <Reviews />
      <Mobilecontact />
      <Footer />
    </>
  );
};

export default Inner;
